export default __webpack_public_path__ + "static/media/powered-by-planpoint-v3.d76995f4.svg";